// import "./App.css";

// function App() {
//   return (
//     <div
//       style={{
//         backgroundColor: "#E1BD77",
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "20px",
//       }}
//     >
//       {/* Logo */}
//       <img
//         src="Wrutten.png"
//         alt="Murgikala logo"
//         style={{
//           width: "50vw",
//           marginBottom: "30px",
//           // borderRadius: "50%",
//           // objectFit: "contain",
//         }}
//         className="brand-logo"
//       />

//       {/* Coming Soon Text */}
//       <div style={{ display: "flex", justifyContent: "center" }}>
//         <h1
//           style={{
//             fontSize: "3rem",
//             fontWeight: "700",
//             color: "#2c2c2c",
//             margin: "0 0 10px 0",
//             letterSpacing: "-1px",
//           }}
//           className="coming-soon-title"
//         >
//           COMING SOON
//         </h1>

//         {/* Brand Illustration */}
//         <img
//           src="murgikala_2.png"
//           alt="Murgikala brand illustration"
//           style={{
//             width: "22vw",
//             // height: "250px",
//             marginBottom: "40px",
//             objectFit: "contain",
//           }}
//           className="brand-illustration"
//         />
//       </div>

//       {/* Email Subscription Optional */}
//       {/* <form
//         style={{
//           marginTop: "50px",
//           display: "flex",
//           gap: "10px",
//           flexWrap: "wrap",
//           justifyContent: "center",
//         }}
//         className="email-form"
//       >
//         <input
//           type="email"
//           placeholder="Enter your email"
//           style={{
//             padding: "12px 20px",
//             fontSize: "1rem",
//             border: "none",
//             borderRadius: "4px",
//             minWidth: "250px",
//             outline: "none",
//           }}
//           className="email-input"
//         />
//         <button
//           type="submit"
//           style={{
//             padding: "12px 30px",
//             fontSize: "1rem",
//             backgroundColor: "#2c2c2c",
//             color: "#E1BD77",
//             border: "none",
//             borderRadius: "4px",
//             cursor: "pointer",
//             fontWeight: "600",
//             transition: "all 0.3s ease",
//           }}
//           className="submit-button"
//           onMouseOver={(e) => {
//             e.target.style.backgroundColor = "#4a4a4a";
//           }}
//           onMouseOut={(e) => {
//             e.target.style.backgroundColor = "#2c2c2c";
//           }}
//         >
//           Notify Me
//         </button>
//       </form> */}
//     </div>
//   );
// }

// export default App;

import "./App.css";

function App() {
  return (
    <div className="landing-container">
      {/* Logo */}
      <img src="Wrutten.png" alt="Murgikala logo" className="brand-logo" />

      {/* Coming Soon & Illustration Group */}
      <div className="coming-soon-group">
        <h1 className="coming-soon-title">COMING SOON</h1>
        <img
          src="murgikala_2.png"
          alt="Murgikala brand illustration"
          className="brand-illustration"
        />
      </div>
    </div>
  );
}

export default App;
